import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { LessonImmersiveTheme } from "../teacher/lessonImmersiveTheme";

export interface ImmersiveSplashProps {
  readonly theme: LessonImmersiveTheme;
  readonly label: string;
}

/**
 * Full-screen themed placeholder shown while a lesson workspace loads. Shares the
 * lesson background + icon watermark so a launch overlay can fade out onto it with
 * no cream flash or layout jump before the real workspace appears.
 */
export function ImmersiveSplash({ theme, label }: ImmersiveSplashProps) {
  return (
    <div className="ide-page ide-page--themed ide-immersive-splash" style={theme.style}>
      <div className="ide-immersive-bg" aria-hidden="true">
        {theme.iconDef ? (
          <FontAwesomeIcon icon={theme.iconDef} className="ide-immersive-watermark" />
        ) : null}
      </div>
      <p className="ide-immersive-splash-label" role="status" aria-live="polite">
        {label}
      </p>
    </div>
  );
}
